import React, { useState } from "react";
import supabase from "../supabaseClient";
import "../styles/global.css";

function Signup() {
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const full_name = event.target.full_name.value;
    const email = event.target.username.value;
    const password = event.target.password.value;
    const confirmPassword = event.target.confirm_password.value;

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    console.log("Registering user with email:", email);

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name, // Pass full_name in user metadata
          },
        },
      });
      console.log("data", data);
      console.log("error", error);
      if (error) {
        throw error;
      }

      if (data.user) {
        window.location.href = "/home";
      }
    } catch (error) {
      console.error("Error during registration:", error);
      setErrorMessage(
        error.message || "Registration failed. Please try again."
      );
    }
  };

  return (
    <div className="container">
      <h1>NÄTUR</h1>
      <form id="registerForm" onSubmit={handleSubmit}>
        <div style={{ textAlign: "left", margin: "auto", width: "200px" }}>
          <label htmlFor="full_name">Full Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Full Name"
            name="full_name"
            required
          />
          <label htmlFor="username">Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            name="username"
            required
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            name="password"
            required
          />
          <label htmlFor="confirm_password">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Confirm Password"
            name="confirm_password"
            required
          />
        </div>

        <br />
        <button type="submit" className="btn btn-custom">
          Register
        </button>
        <button
          type="button"
          className="btn btn-custom"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          {"<-"} Back
        </button>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </form>
    </div>
  );
}

export default Signup;
